import * as React from 'react';
import {connect} from 'react-redux';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {setScreen} from "../../../actions/activation";
import {Share as share} from "../../../actions/update";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  PinterestShareButton,
  VKShareButton,
  OKShareButton,
  RedditShareButton,
  TumblrShareButton,
  LivejournalShareButton,
  MailruShareButton,
  ViberShareButton,
  WorkplaceShareButton,
  LineShareButton,
  PocketShareButton,
  InstapaperShareButton,
  EmailShareButton,
} from 'react-share';

const AppID = '123456';
export class ShareComponent extends React.Component {
	state = {};

	constructor(props) {
		super(props);
	}
	render() {
		const {gloop,videoVersion,options} = this.props;
		if(!options){
			return '';
		}
		const short_url  = (!window.UserId && videoVersion < 3 && !gloop.post_date) ? options.data.storyVideo : gloop.data.short_url;
		const customization_url  = (!window.UserId && (videoVersion < 1 && !gloop.post_date)) ? options.data.storyVideo : gloop.data.customization_url;
		//if(!window.UserId){
			gloop.data.save_photo=customization_url;
			options.data.save_photo=customization_url;
		//}
		return (
			<div className={'share-gloop'}>
				<ul className={'share-buttons'}>
					<li className={'save'}>
						<div className={''}>
							<p>To share your Toing on Facebook, Tiktok, Instagram, WhatsApp etc.</p>
							<a href={(videoVersion > 0 || (gloop.post_date && gloop.data.save_photo)) ? gloop.data.save_photo : options.data.save_photo} className={'save-photo'} download onClick = {()=>{
								window.removeGloop(gloop.ID);
								share('save');
								setScreen('afterShare');
							}}
							>Save to device</a>
						</div>
					</li>
					<li className={'save'}>
						<div className={'save-parent'}>
							<a href={((videoVersion > 0 || (gloop.post_date && gloop.data.save_photo)) ? gloop.data.save_photo : options.data.save_photo).replace('/user-toings.toing.io','/download.user-toings.toing.io').replace('.mp4','.gif').replace('/anonim/','/free-users/')} className={'save-photo'} download onClick = {()=>{
								window.removeGloop(gloop.ID);
								share('Save-gif');
								setScreen('afterShare');
							}}
							>Save as GIF</a>
						</div>
					</li>

					<li className={'email'+(window.UserId ?  '' : ' disabled')}>
						<button
							onClick = {()=>{
								if(window.UserId){
									if(window.SenderUserTotal && window.SenderUserTotal>=50){
										share('Email-limit');
										setScreen('afterShare');
									}else {
										setScreen('createMail');
									}
								}
								else {
									let popup = document.querySelector('.upgrade-info');
									popup.style.display = 'inline-block';
									setTimeout(function () {
										popup.style.display = 'none';
									}, 4000);
								}
							}}
							onMouseEnter={()=>{
								if (!window.UserId) {
									let popup = document.querySelector('.upgrade-info');
									popup.style.display = 'inline-block';
								}
							}}
							onMouseLeave={()=>{
								if (!window.UserId) {
									let popup = document.querySelector('.upgrade-info');
									popup.style.display = 'none';
								}
							}}
						>
							Send by E-mail
						</button>
						{/*<EmailShareButton*/}
						{/*	subject = {'Email share default subject'}*/}
						{/*	url = {short_url}*/}
						{/*	beforeOnClick = {()=>{*/}
						{/*		share('email');*/}
						{/*		setScreen('afterShare');*/}
						{/*	}}*/}
						{/*>*/}
						{/*	Send by E-mail*/}
						{/*</EmailShareButton>*/}
					</li>
					<li className={'Copy'}>
						<CopyToClipboard
							text={window.UserId ? gloop.data.short_url : 'https://toing.io/toing-share-free/?toing='+gloop.data.customization_url.split('/anonim_')[1].replace('.mp4','')}
							onCopy = {()=>{
								window.removeGloop(gloop.ID);
								share('Copy');
								setScreen('afterShare');
							}}
						>
							<button>Share link</button>
						</CopyToClipboard>
					</li>
					{/*<li className={'facebook'}>*/}
					{/*	<FacebookShareButton*/}
					{/*	url = {customization_url}*/}
					{/*		beforeOnClick = {()=>{*/}
					{/*			share('facebook');*/}
					{/*			setScreen('afterShare');*/}
					{/*		}}*/}
					{/*	>*/}
					{/*		Facebook*/}
					{/*	</FacebookShareButton>*/}
					{/*</li>*/}
					{/*<li className={'Linkedin'}>*/}
					{/*	<LinkedinShareButton*/}
					{/*	url = {gloop.data.customization_url}*/}
					{/*		beforeOnClick = {()=>{*/}
					{/*			share('Linkedin');*/}
					{/*			setScreen('afterShare');*/}
					{/*		}}*/}
					{/*	>*/}
					{/*		Linkedin*/}
					{/*	</LinkedinShareButton>*/}
					{/*</li>*/}
					{/*<li className={'Messanger'}>*/}
					{/*	<a onClick={(e) => {*/}
					{/*		share('Messenger');*/}
					{/*		setScreen('afterShare');*/}
					{/*		FB.ui({*/}
					{/*		  method: 'send',*/}
					{/*		  link: short_url,*/}
					{/*		});*/}
					{/*	}} href={'fb-messenger://share/?link='+encodeURIComponent(short_url)+'&app_id='+AppID}>Messenger</a>*/}
					{/*</li>*/}
					{/*<li className={'WhatsApp'}>*/}
					{/*	{window.innerWidth < 720 ?*/}
					{/*		<a*/}
					{/*			// href={'whatsapp://send?text=' + encodeURIComponent(gloop.data.short_url)}*/}
					{/*			href={'https://wa.me/?text=' + encodeURIComponent(short_url)}*/}
					{/*		   onClick={() => {*/}
					{/*			   share('WhatsApp');*/}
					{/*			   setScreen('afterShare');*/}
					{/*		   }}*/}
					{/*		> WhatsApp*/}
					{/*		</a>*/}
					{/*		: <WhatsappShareButton*/}
					{/*			url={short_url}*/}
					{/*			beforeOnClick={() => {*/}
					{/*				share('WhatsApp');*/}
					{/*				setScreen('afterShare');*/}
					{/*			}}*/}
					{/*		>*/}
					{/*			WhatsApp*/}
					{/*		</WhatsappShareButton>}*/}
					{/*</li>*/}
				</ul>
				<a
					href={'href'}
					className={'cancel'}
					onClick={ (e) => {
						e.preventDefault();
						setScreen('gloop');
					}}
				>Cancel</a>
			</div>
		)
	}
}


const mapStateToProps = (state) => {
	const gloop = state.gloops[state.activeGloop];
	let options = null;
	if(gloop && gloop.data){
		options = state.gloopsOptions[gloop.data.original_gloop[0]]
	}
	return {
		ui: state.ui,
		gloop : gloop,
		videoVersion : state.videoVersion,
		options : options
	};
}
const Share = connect(mapStateToProps)(ShareComponent)
export default Share;
